import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';
import Cookies from 'js-cookie';
export const PatientPishNahad = async (
  setLoading,
  idPatient,
  setData
) => {
 
  setLoading(true);

  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_PATIENT_PISH_NAHAD}`,
    true,
    { idPatient: idPatient?.toString() }
  ).then((response) => {
    console.log('======>', response);
    if (response.data.resCode === 1) {
      setData(response?.data?.Data?.lst);
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
    setLoading(false);
  });
};
